import React, { useState, useEffect, useCallback } from "react";
import { View, Text, ScrollView } from "react-native";
import { PieChart } from "react-native-svg-charts";
import { Defs, LinearGradient, Stop } from 'react-native-svg';
import { Feather } from '@expo/vector-icons';
import { formatGPXBalance } from '../../utils/formatNumber'

import HeaderTabs from "../../components/HeaderTabs";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import '../../components/Tabs/react-tabs.css';

import CardsMyTokensWallet from "../../components/CardsMyTokensWallet";
import CardsTransactionsWallet from "../../components/CardsTransactionsWallet";
import CardsCashbackWallet from "../../components/CardsCashbackWallet";
import ScreenLoader from '../../components/ScreenLoader'
import AsyncStorage from '@react-native-async-storage/async-storage';

import api from '../../services/api';

import styles from "./styles";
import CardsMyCertificatesWallet from "../../components/CardsMyCertificatesWallet";

const Wallet = ({ openTransaction }) => {
    const [pageTab, setPageTab] = useState(0);

    const [saldo, setSaldo] = useState(0);
    const [loading1, setLoading1] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [loading3, setLoading3] = useState(false);

    useEffect(() => {
        getBalanceCoin();
        if (openTransaction) {
            setPageTab(1);
        }
    }, []);

    //TODO: LOAD TRANSACTION TAB

    const data = [
        {
            value: 70,
            svg: { fill: 'url(#grad1)' },
            key: 0
        },
        {
            value: 30,
            svg: { fill: 'rgba(35, 35, 35, 0.6)' },
            key: 1
        },
    ];

    const Gradient1 = () => (
        <Defs key={'grad1'}>
            <LinearGradient id={'grad1'} x1={'0%'} y={'0%'} x2={'0%'} y2={'90%'}>
                <Stop offset={'-54.97%'} stopColor={'#1F26BF'} />
                <Stop offset={'120.97%'} stopColor={'#32BFB1'} />
            </LinearGradient>
        </Defs>
    );

    const getBalanceCoin = async () => {
        const token = await AsyncStorage.getItem('JWT_TOKEN');
        setLoading1(true)
        api.get('balanceGpxcoin', { headers: { 'Authorization': `Basic ${token}` } })
            .then((res) => {
                //console.log(res.data)
                if (res.data.balance[0].available_balance) {
                    setSaldo(res.data.balance[0].available_balance);
                } else {
                    setSaldo(res.data.balance[0].saldo);
                }
                setLoading1(false)
            })
            .catch((error) => {
                setLoading1(false)
                console.log("erro2", error);
            })
    }

    return (
        <>
            <ScreenLoader loading={loading1 || loading2 || loading3} />

            <HeaderTabs
                title={"MINHA CARTEIRA"}
                iconLeft={"settings"}
                iconRight={"medal"}
                routeLeft={"MyAccount"}
                routeRight={"MyQualification"}
                subtitle={'Informações sobre seu patrimônio, saldo e transações'}
            />

            <View style={styles.contentCard}>
                <View style={styles.contentCoinGpx}>
                    <Text style={styles.textCoinGpx}>{formatGPXBalance(saldo)} <Text style={{ fontWeight: 'bold' }}>GPX</Text></Text>
                    <View style={styles.hrLineLeft}></View>
                </View>

                <View style={styles.contentGraphic}>
                    <PieChart style={{ height: 107 }}
                        data={data}
                        endAngle="70"
                        startAngle={0}
                        padAngle={0}
                        innerRadius={'70%'}
                        outerRadius={'95%'}
                    >


                        <Gradient1 />
                    </PieChart>
                    <Text style={styles.textMyMoney}>Meu saldo</Text>
                </View>

                <View style={styles.contentCoinBrl}>
                    <Text style={styles.textCoinBrl}>{formatGPXBalance(saldo)} <Text style={{ fontWeight: 'bold' }}>BRL</Text></Text>
                    <View style={styles.hrLineRight}></View>
                </View>
            </View>


            <Tabs defaultIndex={openTransaction ? 1 : 0}>
                <TabList style={{ textAlign: "center" }}>
                    <Tab>Meus tokens</Tab>
                    <Tab>Transações</Tab>
                    <Tab>Certificados</Tab>
                </TabList>
                <TabPanel>
                    <View style={styles.contentPageTab}>
                        <CardsMyTokensWallet saldoGPX={saldo} loading={value => setLoading2(value)} />
                    </View>
                </TabPanel>
                <TabPanel>
                    <View style={styles.contentPageTab}>
                        <CardsTransactionsWallet openFirst={openTransaction} loading={value => setLoading3(value)} />
                    </View>
                </TabPanel>
                <TabPanel>
                    <View style={styles.contentPageTab}>
                        <CardsMyCertificatesWallet />
                    </View>
                </TabPanel>
                {/* <TabPanel>
                    <View style={styles.contentPageTab}>
                        <CardsCashbackWallet />
                    </View>
                </TabPanel> */}
            </Tabs>
        </>

    );
}

export default Wallet;